
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ui": { "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "type": "date picker", "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } } }, "salesUI": { "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "placeholder": "Select a range", "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDateRangeInputs": { "invalidDateRange": "Please select an end date that isn't before the given start date" }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading…" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" } }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option “{{label}}”", "plusMore": "+ {{count}} more", "andMore": "…and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITextToolbarButton": { "remove": "Remove {{name}}", "noop": "You can't {{name}} the current selection" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-2.3984"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-2.3984",
    "ar-eg": "static-2.3984",
    "bg": "static-2.3984",
    "bn": "static-2.3984",
    "ca-es": "static-2.3984",
    "cs": "static-2.3984",
    "da": "static-2.3984",
    "de": "static-2.3984",
    "el": "static-2.3984",
    "en": "static-2.3984",
    "es-mx": "static-2.3984",
    "es": "static-2.3984",
    "fi": "static-2.3984",
    "fr": "static-2.3984",
    "hr": "static-2.3984",
    "hu": "static-2.3984",
    "id": "static-2.3984",
    "it": "static-2.3984",
    "ja": "static-2.3984",
    "ko": "static-2.3984",
    "nl": "static-2.3984",
    "no": "static-2.3984",
    "pl": "static-2.3984",
    "pt-br": "static-2.3984",
    "ro": "static-2.3984",
    "ru": "static-2.3984",
    "sl": "static-2.3984",
    "sv": "static-2.3984",
    "th": "static-2.3984",
    "tr": "static-2.3984",
    "uk": "static-2.3984",
    "vi": "static-2.3984",
    "zh-cn": "static-2.3984",
    "zh-hk": "static-2.3984"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-2.3984'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "hubPicker": { "name": "Name", "domain": "Domain", "users": "Users", "contacts": "Contacts", "products": "Products", "noFilteredResults": "Sorry, no accounts match your filter.", "hubsFailedToLoad": "There was an issue loading your account information. Please try again or select an account below.", "obscuredAccounts": { "description": "Some accounts need you to log in first. When you’ve logged in, you’ll be able to see the data.", "title": "Account information is hidden." } }, "hubRecommend": { "title": "Your accounts", "description": "Use these accounts instead of creating a new one.", "continueButton": "Continue with this account", "showRestButton": "View your other accounts" }, "error": { "noAccounts": { "description": "You have no accounts." }, "requestFailed": { "description": "We couldn't load your accounts. Try refreshing the page." } }, "minimalHubPicker": { "hub": "Hub ID: {{portalId}}" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "hub-pickers-lib": {
    "en": "static-1.4433"
  }
};
  result.translationsAvailable = {
  "hub-pickers-lib": {
    "de": "static-1.4433",
    "en": "static-1.4433",
    "es": "static-1.4433",
    "fr": "static-1.4433",
    "ja": "static-1.4433",
    "nl": "static-1.4433",
    "pt-br": "static-1.4433"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:hub-pickers-lib:en', {version: 'static-1.4433'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "main": { "pageTitle": "Accounts Dashboard Beta | HubSpot", "header": "HubSpot Accounts", "searchText": "Search accounts", "filterText": "Compare sessions:", "filterByWeek": "Week over week", "filterByMonth": "Month over month", "filterByThirtyDay": "Last 30 days" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "hub-picker-ui": {
    "en": "static-1.4456"
  }
};
  result.translationsAvailable = {
  "hub-picker-ui": {
    "de": "static-1.4456",
    "en": "static-1.4456",
    "es": "static-1.4456",
    "fr": "static-1.4456",
    "ja": "static-1.4456",
    "nl": "static-1.4456",
    "pt-br": "static-1.4456"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:hub-picker-ui:en', {version: 'static-1.4456'}); }
})();





